import { Component } from '@angular/core';

@Component({
  selector: 'app-todo',
  imports: [],
  template: `<svg
  width="32"
  height="32"
  viewBox="0 0 31 31"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="1.31396" y="1.26074" width="29" height="29" rx="14.5" fill="white" />
  <rect
    x="1.31396"
    y="1.26074"
    width="29"
    height="29"
    rx="14.5"
    stroke="#E0E0E0"
  />
</svg>
`
})
export class TodoComponent {

}
